const BREADCRUMB_CONFIG = {
  backToHomeRoutes: [
    "/card",
    "/login",
    "/logout",
  ],
  excludedRoutes: [
    "/login",
    "/logout",
    "/otp",
  ],
  excludedPatterns: [
    /^\/404$/,
    /^\/\*$/,
  ],
  maxBreadcrumbLength: 10,
  storageKey: "BREADCRUMB_TRAIL",
};

export const shouldRedirectBackToHome = (route) => {
  const pathname = route.split(/[?#]/)[0];
  return BREADCRUMB_CONFIG.backToHomeRoutes.some(path =>
    pathname === path || pathname.startsWith(path + "/")
  );
};

export const shouldExcludeRoute = (pathname) => {
  const excluded = BREADCRUMB_CONFIG.excludedRoutes.some(route =>
    pathname === route || pathname.startsWith(route + "/")
  );

  if (excluded) return true;

  return BREADCRUMB_CONFIG.excludedPatterns.some(pattern =>
    pattern.test(pathname)
  );
};

export const getRouteLabel = (pathname, translation) => {
  const routeLabels = {
    "/": translation?.home || "Home",
    "/orders": translation?.myOrders || "My Orders",
    "/card": translation?.checkout || "Checkout",
    "/order-detail": translation?.orderDetails || "Order Details",
    "/payment-failed": translation?.paymentFailed || "Payment Failed",
    "/myprofile": translation?.myAccount || "My Account",
    "/order-Confirmation": translation?.orderConfirmation || "Order Confirmation",
    "/order-confirm": translation?.orderConfirm || "Order Confirm",
    "/listing": translation?.listing || "Listing",
    "/tnc": translation?.tnc || "Terms & Conditions",
    "/productlist": translation?.productList || "Product List",
    "/giftcard": translation?.giftCard || "Gift Card",
    "/contact-us": translation?.contactUs || "Contact Us",
    "/order-processing": translation?.orderProcessing || "Order Processing",
    "/processing-payment": translation?.processingPayment || "Processing Payment",
  };

  return routeLabels[pathname] || pathname;
};

export default BREADCRUMB_CONFIG;
